<template>
  <div class="images">
    <h2 class='title is-4'>{{ title_text }}</h2>
    <p>{{ message }}</p>
    <vue-dropzone 
      id="drop1" 
      ref="dropzone"
      :options="dropOptions" 
      @vdropzone-complete="dzAfterEach"
      @vdropzone-queue-complete="dzAfterAll">
    </vue-dropzone>
    <div class='image_thumbs'>
      <figure v-for="(i, idx) in images" v-bind:key="idx">
        <!-- <img v-bind:src="'http://www.allenbrothers.co.uk/uploaded_images/'+i.filename" /> -->
        <img v-bind:src="s3_url + i.filename" />
        <button v-if="$route.params.hasOwnProperty('sku_id')" class='button is-small is-danger' v-on:click="deleteSKUImage(idx)"><span class="icon is-small"><i class="fas fa-trash-alt"></i></span><span>Delete</span></button>
        <button v-if="$route.params.hasOwnProperty('sku_id')" class='button is-small is-info' v-on:click="setMainSKUImage(i.id)"><span class="icon is-small"><i class="fas fa-trash-alt"></i></span><span>Mark main</span></button>
      </figure>
    </div>

    <div v-if="$route.params.hasOwnProperty('sku_id')">
      <hr/>
      <h2 class='title is-4'>PDF drawing for SKU // {{ sku.sku }}</h2>
      <p><a v-if="sku.pdf_drawing_link" :href="sku.pdf_drawing_link">View PDF Drawing</a></p>
      <p>Upload new PDF: <input type="file" id='pdf_file_input' v-on:change="uploadNewPDF" /></p> 
    </div>

  </div>
</template>

<style lang="scss">
.image_thumbs {
  width : 100%;
  display : grid;
  grid-template-columns : repeat(4, 1fr);
  grid-gap: 1em;
  margin : 1rem 0;
}
figure {
  border : 1px solid grey;
  img {
    width : 100%;
    height : auto;
  }
}
</style>

<script>
import vueDropzone from "vue2-dropzone";
export default {
  name : 'images',
  data : function(){
    return {
      title_text     : '',
      message        : '',
      cat            : {},
      product        : {},
      sku            : {},
      boat           : {},
      s3_url         : 'https://abassets.ams3.digitaloceanspaces.com/product_images/',
      images         : [],
      uploaded_urls  : [],
      uploaded_files : [],
      dropOptions : {
        headers: {
          'x-security-token' : '0QA0sr68T858UfSB8osoIwBCeB0Q6E4b5n8Cw9rr'
        },
        addRemoveLinks : true,
        acceptedFiles: "image/jpeg, image/jpg, image/png",
        url : "https://api.allenbrothers.co.uk/v1/images/upload" //"http://127.0.0.1:4000/v1/images/upload" //
      }
    }
  },
  components : {
    vueDropzone
  },
  mounted(){
    // Y375SV6MPEHKKR3B6I6B // key
    // wmLrP7AAIaXMgg5SPPz/xfWgnhq+QHk1PDlJxuzRHGE // secret
    console.log({ ROUTE_PARMS : this.$route.params });
    if(this.$route.params.hasOwnProperty('cat_id')){
      this.getCategory(this.$route.params.cat_id);
    }
    if(this.$route.params.hasOwnProperty('prod_id')){
      this.getProduct(this.$route.params.prod_id);
    }
    if(this.$route.params.hasOwnProperty('sku_id')){
      this.getSKU(this.$route.params.sku_id, () => {
        this.getSKUImages();
      });
    }
    if(this.$route.params.hasOwnProperty('boat_id')){
      this.getBoat(this.$route.params.boat_id);
    }
  },
  methods : {
    getCategory : function(cat_id){
      this.callAPI('get', 'categories/'+ cat_id, {})
        .then((res) => {
          this.cat = res.data.categories[0];
          // console.log('CATEGORY', this.cat);
          this.title_text = "Images for Category // "+ this.cat.title;
          this.message = "NB. Categories only have one image, only the first image will be used if many are uploaded at once.";
          this.images = [{ filename : this.cat.filename }];
        })
        .catch((err) => { console.error(err); });
    },
    getProduct : function(prod_id){ //page, return_count
      this.callAPI('get', 'products/'+ prod_id, {})
        .then((res) => {
          this.product = res.data.products[0];
          // console.log(this.product);
          this.title_text = "Images for product // "+ this.product.title;
          this.message = "NB. Categories only have one image, only the first image will be used if many are uploaded at once.";
          this.images = [{ filename : this.product.filename }];
        })
        .catch((err) => { console.error(err); });
    },
    getSKU : function(id, next){
      this.callAPI('get', '/products/null/skus/'+ id, { show_hidden : true })
        .then((res) => {
          console.log({ res });
          this.sku = res.data.skus[0];
          this.title_text = "Images for SKU // "+ this.sku.sku;
          // console.log(this.sku);
          if(next){
            next();
          }
        })
        .catch((err) => { console.error(err); });
    },
    getSKUImages : function(){
      this.callAPI('get', '/products/'+ this.sku.id +'/images', {})
        .then((res) => {
          this.images = res.data.images;
          this.uploaded_files = [];
          this.uploaded_urls = [];
          // console.log(this.images);
        })
        .catch((err) => { console.error(err); });
    },
    getBoat : function(boat_id){
      this.callAPI('get', `boats/${boat_id}`, {})
        .then((res) => {
          this.boat = res.data[0];
          console.log(this.boat);
          this.title_text = "Images for boat // "+ this.boat.boat_title;
          this.message = "NB. Boats only have one image, only the first image will be used if many are uploaded at once.";
          this.images = [{ filename : this.boat.filename }];
        })
        .catch((err) => { console.error(err); });
    },
    deleteSKUImage : function(idx){
      if(confirm("Are you sure you want to delete this image, this cannot by undone!")){
        // console.log('DELETE', this.images[idx]);
        this.callAPI('put', `/products/${this.sku.id}/images/${this.images[idx].id}/delete`, { filekey : `product_images/${this.images[idx].filename}` })
          .then((res) => {
            this.getSKUImages();
          })
          .catch((err) => { console.error(err); });
      }
    },
    dzAfterEach : function(file){
      // console.log(file);
      if(file.status === 'success'){
        this.uploaded_files.push(file.name);
        this.uploaded_urls.push(this.s3_url+file.name);
      }
    },
    dzAfterAll : function() {
      // console.log('All done!', this.uploaded_files, this.uploaded_urls);
      this.$refs.dropzone.removeAllFiles();
      if(this.$route.params.hasOwnProperty('cat_id')){
        this.updateImageToCategory();
      }
      if(this.$route.params.hasOwnProperty('prod_id')){
        this.updateImageToProduct();
      }
      if(this.$route.params.hasOwnProperty('sku_id')){
        // this.getSKU(this.$route.params.sku_id);
        this.addImagesToSKU();
      }
      if(this.$route.params.hasOwnProperty('boat_id')){
        this.updateImageToBoat();
      }
    },
    updateImageToCategory : function(){
      let filename = this.uploaded_files[0];
      this.callAPI('put', 'categories/'+ this.cat.id +'/image', { 
          filename : this.uploaded_files[0], 
          fileurl : this.uploaded_urls[0], 
          wc_id : this.cat.wc_id 
        }).then((res) => {
          this.getCategory(this.cat.id);
        })
        .catch((err) => { console.error(err); });
    },
    updateImageToBoat : function(){
      let filename = this.uploaded_files[0];
      this.callAPI('put', 'boats/'+ this.boat.id +'/image', { 
          filename : this.uploaded_files[0]
        }).then((res) => {
          this.getBoat(this.boat.id);
        })
        .catch((err) => { console.error(err); });
    },
    updateImageToProduct : function(){
      let filename = this.uploaded_files[0];
      this.callAPI('put', 'products/'+ this.product.id +'/images', { 
          filename : this.uploaded_files[0], 
          fileurl : this.uploaded_urls[0], 
          wc_id : this.product.wc_id 
        }).then((res) => {
          this.getProduct(this.product.id);
        })
        .catch((err) => { console.error(err); });
    },
    addImagesToSKU : function(){
      this.callAPI('post', '/skus/'+ this.sku.id +'/images', { images : this.uploaded_urls, wc_id : this.sku.wc_id }) // existing : this.images.map((i) => this.s3_url+i.filename), 
        .then((res) => {
          // console.log(res);
          this.getSKUImages();
        })
        .catch((err) => { console.error(err); });
    },
    setMainSKUImage : function(main_id){
      this.showSpinner(true);
      let s3_url = this.s3_url;
      let main_image_id = '';
      let all_images = this.images.map((a) => {
        if(a.id === main_id){ main_image_id = a.id; }
        return {
          src : s3_url + a.filename,
          position : (a.id === main_id ? 0 : 2)
        }
      });
      this.callAPI('put', '/skus/'+ this.sku.id +'/images/setmain', { images : all_images, wc_id : this.sku.wc_id, main_image_id })
        .then((res) => {
          this.getSKUImages();
          this.showSpinner(false);
        })
        .catch((err) => { console.error(err); });
    },
    uploadNewPDF : function(e){
      let files = e.target.files || e.dataTransfer.files;
      if(files.length){ 
        // console.log(files[0]);
        let formdata = new FormData();
        formdata.append('file', files[0]);
        formdata.append('wc_id', this.sku.wc_id);
        // console.log(formdata);
        this.callAPI('post', '/skus/'+ this.sku.id +'/pdf/', formdata)
          .then((res) => {
            // console.log(res);
            document.getElementById('pdf_file_input').value = null;
            this.getSKU(this.sku.id);
          })
          .catch((err) => { console.error(err); });
      }
    }
  }
};
</script>